import React, { Component, createRef } from 'react';
import { tree } from 'd3-state-visualizer';
const wrapperStyle = {
    width: '100%',
    height: '100%',
};
class Chart extends Component {
    constructor() {
        super(...arguments);
        this.divRef = createRef();
    }
    componentDidMount() {
        const { select, state, defaultIsVisible } = this.props;
        this.renderChart = tree(this.divRef.current, this.props);
        if (defaultIsVisible) {
            // eslint-disable-next-line @typescript-eslint/no-empty-object-type
            this.renderChart(select(state));
        }
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { state, select, monitorState } = nextProps;
        if (monitorState.isVisible !== false) {
            // eslint-disable-next-line @typescript-eslint/no-empty-object-type
            this.renderChart(select(state));
        }
    }
    render() {
        return React.createElement("div", { style: wrapperStyle, ref: this.divRef });
    }
}
export default Chart;
